import { Injectable, EventEmitter } from "@angular/core"
import { environment } from "../../../../environments/environment"
export let isDebugMode = environment.isDebugMode

@Injectable()
export class ModalUploadFileService {

  eventOpen = new EventEmitter<boolean>()
  //tableid: string
  //recidkey: string

  constructor() {
    isDebugMode ? console.log(`constructor()`) : undefined
  }
}
